import { z } from 'zod';

export const forgotPasswordDtoSchema = z.object({
  email: z.string().email('Vul een geldig e-mailadres in.'),
});

export type ForgotPasswordDto = z.infer<typeof forgotPasswordDtoSchema>;
